import StorehouseProduct from '@/models/storehouseProduct';

export default () => {
  if (Array.isArray(window.axios.defaults.transformResponse)) {
    return window.axios.defaults.transformResponse.concat(
      (storehouseProductProps: any) => StorehouseProduct.createFromRequest(storehouseProductProps)
    );
  }
};
